import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import { ComponentPropsWithoutRef } from 'react'

const inputVariants = cva('placeholder:text-muted flex w-full py-3 text-base file:border-0 file:bg-transparent file:text-current disabled:cursor-not-allowed disabled:opacity-50', {
  variants: {
    variant: {
      default: 'focus-visible:miista-focus h-10 rounded-lg border border-solid border-current px-3',
      underlined: 'focus-visible:outline-hidden h-10 border-b-2 border-current bg-transparent',
      search: 'focus-visible:outline-hidden appearance-none bg-transparent text-3xl font-light italic sm:text-4xl md:text-5xl lg:text-8xl [&::-webkit-search-cancel-button]:hidden',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

function Input({ className, type, variant, ...props }: ComponentPropsWithoutRef<'input'> & VariantProps<typeof inputVariants>) {
  return <input type={type} data-slot='input' className={cn(inputVariants({ variant }), className)} {...props} />
}

export { Input }
